import {
    Box,
    Button,
    Grid,
    makeStyles,
    TextField,
} from "@material-ui/core";
import {Close} from "@material-ui/icons";
import React from "react";
import {
    Controller,
    useFieldArray,
    useWatch
} from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const filmScreeningsDefaultValue = {
    year: "",
    desc: "",
};

const useStyles = makeStyles((theme) => ({
    filmScreeningsBlk: {
        background: "#FFFFFF",
        marginBottom: "20px",
    },
    filmScreeningsBlkHeader: {
        background: "#EDEEF0",
        borderLeft: "3px solid #9D3030",
        fontWeight: "bold",
        fontSize: "14px",
        lineHeight: "16px",
        padding: "12px 13px",
    },
    filmScreeningsBlkBody: {
        border: "1px solid #CCCCCC",
        borderTop: "0px",
        padding: "20px 13px",
    },
    deleteBtn: {
        margin: "0",
        padding: "0",
        minWidth: "initial",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
}));

const FilmographyBlock = ({
                              control,
                              index,
                              classes,
                              disabled,
                              remove,
                              data,
                              dataTc,
                              setValue,
                              directorIndex
                          }) => {

    return (
        <>
            <Grid
                container
                className={classes.filmScreeningsBlkHeader}
                xs={12}
                alignItems="center"
                justify="space-between"
            >
                <span>Selected Filmography {index + 1}</span>
                {disabled || (
                    <Button className={classes.deleteBtn}
                            onClick={() => remove(index)}>
                        <Close style={{
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}/>
                    </Button>
                )}
            </Grid>
            <Box className={classes.filmScreeningsBlkBody}>
                <Grid container spacing={3}
                      direction="column">
                    <Grid container item xs={12}>
                        <Grid item xs={4}>
                            <Controller
                                defaultValue={data?.year}
                                name={`localizations.en.directors.directors[${directorIndex}].filmography[${index}].year`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Year"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        InputLabelProps={{shrink: true}}
                                        {...rest}
                                        onChange={(event) => {
                                            setValue(`localizations.en.directors.directors[${directorIndex}].filmography[${index}].year`, event.target.value);
                                            setValue(`localizations.tc.directors.directors[${directorIndex}].filmography[${index}].year`, event.target.value);
                                        }}
                                        value={value}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <Controller
                                defaultValue={data?.desc}
                                name={`localizations.en.directors.directors[${directorIndex}].filmography[${index}].desc`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Movie Name (English)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        InputLabelProps={{shrink: true}}
                                        {...rest}
                                        onChange={(event) => {
                                            setValue(`localizations.en.directors.directors[${directorIndex}].filmography[${index}].desc`, event.target.value);
                                        }}
                                        value={value}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <Controller
                                defaultValue={dataTc?.desc}
                                name={`localizations.tc.directors.directors[${directorIndex}].filmography[${index}].desc`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Movie Name (Traditional Chinese)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        InputLabelProps={{shrink: true}}
                                        {...rest}
                                        onChange={(event) => {
                                            setValue(`localizations.tc.directors.directors[${directorIndex}].filmography[${index}].desc`, event.target.value);
                                        }}
                                        value={value}
                                    />
                                )}
                            />
                        </Grid>

                    </Grid>

                </Grid>
            </Box>
        </>
    );
};

export default function MainDirectorSelectedFilmographySections(props) {
    const {
        control,
        setValue,
        disabled,
        directorIndex
    } = props;

    const {fields, append, remove} = useFieldArray({
            control,
            name: `localizations.en.directors.directors[${directorIndex}].filmography`
    })

    const {fields: fieldsTc , append: appendTc, remove: removeTc } = useFieldArray({
            control,
            name: `localizations.tc.directors.directors[${directorIndex}].filmography`
    })

    const classes = useStyles();

    const removeFilmography = (index) => {
        remove(index);
        removeTc(index);
    }

    return (
        <>
            {fields.map((data, index) => (
                <div className={classes.filmScreeningsBlk}
                     key={data.id}>
                    <FilmographyBlock
                        {...{
                            control,
                            index,
                            classes,
                            disabled,
                            remove: removeFilmography,
                            data,
                            dataTc: fieldsTc[index],
                            setValue,
                            directorIndex
                        }}
                    />
                </div>
            ))}
            {disabled || (
                <Button
                    type="button"
                    onClick={() => {
                        append(filmScreeningsDefaultValue);
                        appendTc(filmScreeningsDefaultValue);
                    }}
                    style={{
                        color: "#306F9D",
                        margin: "5px 0",
                    }}
                >
                    <AddCircleIcon/>
                    Add Filmography
                </Button>
            )}
        </>
    );
}